import { render, staticRenderFns } from "./treaty.vue?vue&type=template&id=fc0b411e&scoped=true"
import script from "./treaty.vue?vue&type=script&lang=js"
export * from "./treaty.vue?vue&type=script&lang=js"
import style0 from "./treaty.vue?vue&type=style&index=0&id=fc0b411e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc0b411e",
  null
  
)

export default component.exports